/* Canais / onboarding: criação, conexão e importação de histórico. */
import {
  channel,
  connectResult,
  createChannelInput,
  importHistoryInput,
  importHistoryResult,
  type Channel,
  type ConnectResult,
  type CreateChannelInput,
  type ImportHistoryResult,
} from "@zapir/shared";
import { request } from "./core";

export const channelsApi = {
  async channels(): Promise<Channel[]> {
    return request("/channels", { schema: channel.array() });
  },

  async createChannel(input: CreateChannelInput): Promise<Channel> {
    const body = createChannelInput.parse(input);
    return request("/channels", { method: "POST", body, schema: channel });
  },

  async connectChannel(id: string): Promise<ConnectResult> {
    return request(`/channels/${id}/connect`, { method: "POST", schema: connectResult });
  },

  async disconnectChannel(id: string): Promise<void> {
    await request(`/channels/${id}/connect`, { method: "DELETE" });
  },

  async deleteChannel(id: string): Promise<void> {
    await request(`/channels/${id}`, { method: "DELETE" });
  },

  async importChannelHistory(id: string, days: number | null): Promise<ImportHistoryResult> {
    return request(`/channels/${id}/import-history`, {
      method: "POST",
      body: importHistoryInput.parse({ days }),
      schema: importHistoryResult,
    });
  },
};
